<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { AlertTriangle, HelpCircle } from 'lucide-vue-next'

import { useConfirm } from '@/composables/useConfirm'

const { estado, responder } = useConfirm()
const botonConfirmar = ref<HTMLButtonElement | null>(null)

// Enfoca el botón principal al abrir para que Enter confirme y Esc cancele.
watch(
  () => estado.visible,
  async (v) => {
    if (v) {
      await nextTick()
      botonConfirmar.value?.focus()
    }
  },
)
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-150"
    enter-from-class="opacity-0"
    leave-active-class="transition-opacity duration-150"
    leave-to-class="opacity-0"
  >
    <div
      v-if="estado.visible"
      class="fixed inset-0 z-[70] grid place-items-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
      :aria-label="estado.titulo"
      @click.self="responder(false)"
      @keydown.esc.prevent="responder(false)"
    >
      <div class="w-full max-w-sm" :class="estado.peligroso ? 'card-accent-danger' : 'card-accent'">
        <div class="card-body space-y-4">
          <div class="flex items-start gap-3">
            <div
              class="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full"
              :class="estado.peligroso ? 'bg-danger/15 text-danger' : 'bg-accent/15 text-accent'"
            >
              <AlertTriangle v-if="estado.peligroso" :size="18" />
              <HelpCircle v-else :size="18" />
            </div>
            <div class="min-w-0">
              <h3 class="text-base font-semibold leading-snug">{{ estado.titulo }}</h3>
              <p v-if="estado.mensaje" class="mt-1 text-sm text-fg-muted">{{ estado.mensaje }}</p>
            </div>
          </div>
          <div class="flex flex-col-reverse gap-2 sm:flex-row">
            <button class="btn-secondary flex-1" @click="responder(false)">{{ estado.cancelar }}</button>
            <button
              ref="botonConfirmar"
              class="flex-1"
              :class="estado.peligroso ? 'btn-danger' : 'btn-primary'"
              @click="responder(true)"
            >
              {{ estado.confirmar }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
